import { useState, useEffect } from 'react';

// Automatically load all images from src/images folder
const importAll = (r) => {
  return r.keys().map(r);
};

const useImageLoader = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadImages = () => {
      try {
        setLoading(true);
        setError(null);

        // Use require.context to automatically import all images from src/images folder
        // This will include all files with extensions: .jpg, .jpeg, .png, .gif, .webp, .bmp, .svg
        let imageContext;
        try {
          imageContext = require.context('../images', false, /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i);
        } catch (e) {
          // If no images folder exists or no images are found, return empty array
          console.warn('No images found in src/images folder:', e.message);
          setImages([]);
          setLoading(false);
          return;
        }

        // Import all images
        const importedImages = importAll(imageContext);

        // Sort images by filename for consistent ordering
        const sortedImages = importedImages.sort((a, b) => {
          const aName = a.split('/').pop().split('.')[0];
          const bName = b.split('/').pop().split('.')[0];
          return aName.localeCompare(bName, undefined, { numeric: true, sensitivity: 'base' });
        });

        setImages(sortedImages);
      } catch (err) {
        setError(`Failed to load images: ${err.message}`);
        console.error('Image loading error:', err);
      } finally {
        setLoading(false);
      }
    };

    loadImages();
  }, []);

  return { images, loading, error };
};

export default useImageLoader;
